import { render, staticRenderFns } from "./stepDocumentFieldsPreview.vue?vue&type=template&id=60f165e7&scoped=true&"
import script from "./stepDocumentFieldsPreview.vue?vue&type=script&lang=js&"
export * from "./stepDocumentFieldsPreview.vue?vue&type=script&lang=js&"
import style0 from "./stepDocumentFieldsPreview.vue?vue&type=style&index=0&id=60f165e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f165e7",
  null
  
)

export default component.exports